import _ from "lodash";

import { Service, Module } from "app/decorators";
import SignatureService from "app/services/signature";

@Module({
  name: "app.services.secure.url.generator",
  modules: [SignatureService],
})
@Service("SecureUrlService")
export default class SecureUrlService {
  constructor($q, $window, $httpParamSerializer, SignatureService, $http) {
    "ngInject";
    this.signatureService = SignatureService;
    this.$q = $q;
    this.$httpParamSerializer = $httpParamSerializer;
    this.$window = $window;
    this.$http = $http;
  }

  generateUrl(object, qs) {
    let self = this;
    let urlPromise = self.$q.defer();

    self.signatureService.get().then((signature) => {
      let url = object.getRequestedUrl();
      let params = qs || {};
      params = _.extend(params, { signature: signature });
      let query = self.$httpParamSerializer(params);

      urlPromise.resolve(`${url}?${query}`);
    });

    return urlPromise.promise;
  }

  generateMixCalculatorPdf(object, qs) {
    let self = this;

    let response = self.signatureService.get().then((signature) => {
      let url = object.getRequestedUrl();
      let params = qs || {};
      params = _.extend(params, { signature: signature });

      // replace ';' for ',' because the semicolon is not supported in the paramSerializer
      params.products.forEach(function (product) {
        if (product.product.dot) {
          product.product.dot = product.product.dot.replaceAll(';', ',')
        }
      });

      let query = self.$httpParamSerializer(params);
      let _signature = self.$httpParamSerializer({ signature: signature });

      let promise = this.$http({
        method: "POST",
        url: `${url}?${_signature}`,
        data: query,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        responseType: "arraybuffer",
      }).then(function (_response) {
        return _response;
      });
      return promise;
    });
    return response;
  }

  openInNewWindow(object, qs) {
    let self = this;

    if (typeof qs === 'undefined' || !qs.acres) {
      self.generateUrl(object, qs).then((url) => {
        self.$window.open(url, "_blank");
      });
    } else {
      self.generateMixCalculatorPdf(object, qs).then((url) => {
        var file = new Blob([url.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        self.$window.open(fileURL, "_blank");
      });
    }
  }

  redirect(object, qs) {
    let self = this;
    self.generateUrl(object, qs).then((url) => {
      self.$window.location = url;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/secure.url.js